// extracted by mini-css-extract-plugin
export default {"checkoutInput":"checkoutDetails_checkoutInput__k3ZH7"};